import React from 'react'

function IconCreateBlog({ fill = '' }) {
  return (
    <svg 
      width="24" 
      height="24" 
      className={fill} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 2.64733C15.7363 2.5 14.1188 2.5 12 2.5C7.52166 2.5 5.28249 2.5 3.89124 3.89124C2.5 5.28249 2.5 7.52166 2.5 12C2.5 16.4783 2.5 18.7175 3.89124 20.1088C5.28249 21.5 7.52166 21.5 12 21.5C16.4783 21.5 18.7175 21.5 20.1088 20.1088C21.5 18.7175 21.5 16.4783 21.5 12C21.5 10.7939 21.5 9.75024 21.4728 8.8418"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 10H11" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M10 15H14" strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M14.9577 11.4622V10.5088C14.9577 8.63614 14.9577 7.69981 14.4825 7.04341C13.5821 5.79972 11.833 6.01409 10.4788 6.01409C9.12474 6.01409 7.37562 5.79972 6.47521 7.04341C6 7.69981 6 8.63614 6 10.5088V13.0059C6 15.3601 6 16.5373 6.72879 17.2686C7.45758 18 8.63055 18 10.9765 18H14.6862C17.285 18 18.3239 16.1725 17.913 13.5687C17.6684 12.0195 16.3315 11.4622 14.9577 11.4622Z"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M20.6221 2.56564C20.8457 2.32342 20.9574 2.20232 21.0762 2.13168C21.3628 1.96123 21.7157 1.95593 22.0071 2.1177C22.1279 2.18474 22.2431 2.30244 22.4735 2.53783C22.7039 2.77322 22.8192 2.89092 22.8848 3.01428C23.0431 3.31194 23.038 3.67244 22.8711 3.96521C22.8019 4.08655 22.6834 4.20073 22.4463 4.4291L19.6252 7.14629C19.1759 7.57906 18.9512 7.79545 18.6704 7.90512C18.3896 8.0148 18.081 8.0067 17.4636 7.99057L17.3796 7.98838C17.1917 7.98346 17.0977 7.98101 17.0431 7.91901C16.9885 7.85702 16.9959 7.7613 17.0108 7.56985L17.0189 7.4659C17.0609 6.92706 17.0819 6.65765 17.1871 6.41547C17.2923 6.17328 17.4738 5.97664 17.8368 5.58335L20.6221 2.56564Z"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M20 3L22 5" />
    </svg>
  )
}

export default IconCreateBlog